<div class="comments">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.TrailerCard, langText.Comments)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body">
    <p><strong>{{localize(langSection.Term, langText.Location)}}:</strong> {{request.slicName}} ({{customName}})</p>
    <p><strong>{{localize(langSection.RequestDetailsPage, langText.RequestId)}}:</strong> {{request.requestId}}</p>
    <p><strong>{{localize(langSection.CancelModal, langText.RequestType)}}:</strong> {{localizeValue(langSection.RequestType, request.requestType)}}</p>
    @if (request.requestCategory !== 'Planned') {
<p><strong>{{localize(langSection.Term, langText.Date)}}:</strong> {{request.earliestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}} {{localize(langSection.TimeZones, request.timezoneName)}} - {{request.latestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}} {{localize(langSection.TimeZones, request.timezoneName)}}</p>
}
    @if (request.requestCategory === 'Planned') {
<p><strong>{{localize(langSection.Term, langText.Date)}}:</strong> {{request.earliestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}} {{localize(langSection.TimeZones, request.timezoneName)}}</p>
}

    <div class="outer-container">
      <div class="header">
        <span>{{localize(langSection.CommentsModal, langText.PreviousComments)}}</span>
        <div class="refresh-container">
          <span class="comment-refresh">{{localize(langSection.CommentsModal, langText.CommentRefresh)}}</span>
          <ngb-progressbar class="comments-loading-bar" type="secondary" [value]="refreshPercent"></ngb-progressbar>
        </div>
      </div>
      <div #commentsContainer [scrollTop]="commentsContainer.scrollHeight" class="comments-container">
          @for (comment of request.comments; track comment; let i = $index) {
<div>
            <div class="comment">@if (comment.localUnread) {
<span class="unread-message-icon"></span>
}<strong>{{comment.systemName === "UPS" ? comment.systemName : comment.userUpsId}}:</strong> ({{comment.timeStamp | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm"}}) {{comment.text}}</div>
          </div>
}
      </div>
    </div>

    @if (!request.isViewOnly) {
<div>
      <p><strong>{{localize(langSection.CommentsModal, langText.AddComment)}}</strong>
      <span class="float-right">{{newComment.length}}/256</span>
      </p>
      <textarea maxlength="256" [(ngModel)]="newComment" class="form-control"></textarea>
    </div>
}

  </div>
  @if (!request.isViewOnly) {
<div>
    <div class="modal-footer">
      <button type="button" class="btn btn-green" [class.disabled]="newComment.length == 0" [disabled]="newComment.length == 0" (click)="submit()">{{  localize(langSection.Term, langText.Submit)}}</button>
      @if (submitError) {
<div class="text-danger">{{localize(langSection.CommentsModal, langText.FailedToSubmit)}}</div>
}
    </div>
  </div>
}
</div>
